import { AES } from "crypto-js";

// Kunci rahasia yang digunakan untuk enkripsi
const secretKey = "UIPOEHJSLDYRGDJS";

// Fungsi untuk mengenkripsi dan menyimpan data di local storage
export const encryptStringLocalStorage = (key, value) => {
  const encryptedValue = AES.encrypt(value, secretKey).toString();
  localStorage.setItem(key, encryptedValue);
};
